export const generateTwClasses = (prefix: string, suffix: string) => {
  if (!suffix || suffix === '') return ''
  return `${prefix}-${suffix}`
}
